<template>
    <div class="page-cabinet-profile-juridical">
        <ui-infolist
            v-bind:info="info"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'page-cabinet-profile-juridical',
    computed: {
        ...mapState('users', [
            'getUserProfileResult',
            'getUserJuridicalInfoResult',
        ]),
        info() {
            let result = [];
            if (this.getUserProfileResult.legalType === 'I') {
                result = result.concat([
                    { title: 'Название', value: this.getUserJuridicalInfoResult.organizationName, isCopyAllowed: true },
                    { title: 'Адрес', value: this.getUserJuridicalInfoResult.organizationAddress, isCopyAllowed: true },
                    { title: 'ОГРНИП', value: this.getUserJuridicalInfoResult.ogrn, isCopyAllowed: true },
                ]);
            }
            if (this.getUserProfileResult.legalType === 'J') {
                result = result.concat([
                    { title: 'Сокращенное наименование организации', value: this.getUserJuridicalInfoResult.organizationName, isCopyAllowed: true },
                    { title: 'ИНН', value: this.getUserJuridicalInfoResult.inn, isCopyAllowed: true },
                    { title: 'КПП', value: this.getUserJuridicalInfoResult.kpp, isCopyAllowed: true },
                    { title: 'ОГРН', value: this.getUserJuridicalInfoResult.ogrn, isCopyAllowed: true },
                    { title: 'Юридический адрес', value: this.getUserJuridicalInfoResult.organizationAddress, isCopyAllowed: true },
                    { title: 'Фактический адрес', value: this.getUserJuridicalInfoResult.legalAddress, isCopyAllowed: true },
                    { title: 'Почтовый адрес', value: this.getUserJuridicalInfoResult.mailingAddress, isCopyAllowed: true },
                    // { title: 'Полное название', value: this.getUserJuridicalInfoResult.organizationNameFull, isCopyAllowed: true },
                    // { title: 'Банк', value: this.getUserJuridicalInfoResult.bankName, isCopyAllowed: true },
                    // { title: 'ОКВЕД', value: this.getUserJuridicalInfoResult.okved, isCopyAllowed: true },
                    // { title: 'БИК', value: this.getUserJuridicalInfoResult.bik, isCopyAllowed: true },
                    // { title: 'Корр. счет', value: this.getUserJuridicalInfoResult.ogrn, isCopyAllowed: true },
                    // { title: 'Дата регистрации', value: this.getUserJuridicalInfoResult.dateRegistration, isCopyAllowed: true },
                ]);
            }
            return result;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-profile-juridical {}
</style>
